<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "UserMapping",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  